
import TvPlanItems from '../internettv/TvPlanItems.vue'

export default {
    name: 'tv-plans',
    components: {
        'jt-tv-plan-items': TvPlanItems
    }
}
